export default __webpack_public_path__ + "static/media/elementaryLibrary.10f08dd3.svg";